<div>
<h2 class="title m-2">Asset Link <em class="ti-close pull-right" style="color: red; cursor: pointer;" (click)="onClose()"></em> </h2>
<pipelineassetpopup-search
  [task]="task"
  (searchEmit)="onSearch($event)"
  (emitTask)="onTask($event)"
>
</pipelineassetpopup-search>

<ng-container [ngSwitch]="task">
  <ng-template >
    <pipelineassetpopup-list
      [landTitles]="searchedLandTitle"
      (emitLandTitle)="onViewTask($event)"
      (taskEmit)="onTask($event)">
<!-- ngSwitchCase="create" -->
  </pipelineassetpopup-list>
  </ng-template>
  <ng-template ngSwitchCase="list">
<div class="title pull-right">
  <button class="default_secondary-btn relatives" style="justify-content: right;" (click)="onSubmit()">Add</button>
</div>
<!-- <div class="search_container">
  <input type="text" class="default_input search"
  placeholder="Search asset name"
  #name (keyup)="selectPipelineAsset(name.value)"/>
  <em class="ti-search"></em> 
</div> -->
<table class="table table-hover scroll">
  <thead>
    <tr>
      <th scope="col">S/N</th>
      <th scope="col">Land Name</th>
      <th scope="col">Field Name</th>
      <th scope="col">Location Name</th>
      <th scope="col">Check</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let pipelineasset of pipelineassetFormArray.get('PipelineAssetLinks')['controls']; index as i"
    matTooltip="Click on check box to add"
      aria-label="Button that displays a tooltip when focused or hovered over">
      <th scope="row">{{i + 1}}</th>
      <td>
        <div class="the_input">
          <span class="content">{{pipelineasset.value.LandName}}</span>
      </div>
    </td>
      <td>
        <div class="the_input">
          <span class="content">{{getSubSubGroupName(pipelineasset.value.SubSubGroupId)}}</span>
        </div>
      </td>
      <td>
        <div class="the_input">
          <span class="content">{{getCategoryName(pipelineasset.value.CategoryId)}}</span>
        </div>
      </td>
      <td>
        <span class="content" (click)="$event.stopImmediatePropagation()" (click)="checkPipelineAsset(pipelineasset.value)" >
          <input type="checkbox" style="cursor: pointer;" (click)="checkPipelineAsset(pipelineasset.value)" [checked]="checkSelected(pipelineasset.value.LandName)">
          <!-- <mat-checkbox  (click)="checkPipelineAsset(pipelineasset.value)" color="primary"></mat-checkbox> -->
        </span>
      </td>
    </tr>

  </tbody>
</table>
</ng-template>
</ng-container>
</div>

<cradua-list-spinner
*ngIf="isLoadingLandTitle === true"
>
</cradua-list-spinner>